import H from 'history'

/**
 * Only show discount for related topic on breach screen
 */
export function showBreachForTopic(
    location: H.Location,
    breachEnabled: boolean,
    topic: string,
) {
    const path = location.pathname.split('/')
    return breachEnabled && path.length > 0 ? path[1] === topic : false
}

export function showBreachDiscount(
    location: H.Location,
    featureEnabled: boolean,
) {
    return featureEnabled && location.pathname.length > 0
        ? location.pathname.includes('lisa-govan')
        : false
}
